import React, { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

import CourierService from './components/CourierService';
import PickupPoint from './components/PickupPoint';

import DeliveryMode from '../../models/DeliveryMode';

import { MenuItem, Stack } from '@mui/material';
import TextFieldControlled from 'components/shared/TextFieldControlled';

import { DELIVERY_MODES_WITH_LABEL } from '../../constants/deliveryModes';

import { useTranslation } from 'react-i18next';
import type RefundForm from '../../models/RefundForm';

const ShippingDetailsStep: React.FC = () => {
    const { t } = useTranslation('refund', {
        keyPrefix: 'SHIPPING_DETAILS_STEP',
    });

    const form = useFormContext<RefundForm>();

    const mode = form.watch('mode');

    const shippingDetailsForm = useMemo(() => {
        switch (mode) {
            case DeliveryMode.COURIER_SERVICE:
                return (
                    <CourierService
                        formBase="courier_service"
                        key="courier_service"
                    />
                );
            case DeliveryMode.TRANSIT:
                return <CourierService formBase="transit" key="transit" />;
            case DeliveryMode.PICKUP_POINT:
                return <PickupPoint />;
            default:
                return null;
        }
    }, [mode]);

    return (
        <Stack gap={2}>
            <TextFieldControlled
                label={t('DELIVERY_MODE')}
                control={form.control}
                name="mode"
                select
            >
                {DELIVERY_MODES_WITH_LABEL?.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </TextFieldControlled>

            {shippingDetailsForm}
        </Stack>
    );
};

export default ShippingDetailsStep;
